import { ui } from "@/components/ui";
import TemplateInfoDialog from "@/features/templates/components/TemplateInfoDialog";
import TemplateQRCode from "@/features/templates/components/TemplateQRCode";
import { createFileRoute } from "@tanstack/react-router";

const QRCodeInvitePage = () => {
  const { template } = Route.useSearch();

  return (
    <div className="flex flex-col justify-center items-center gap-8 bg-slate-50 py-8 min-h-screen">
      <ui.Card className="flex flex-col items-center gap-4 shadow-lg p-6 w-full max-w-md">
        <TemplateQRCode template={template} />
        <div className="flex justify-end w-full">
          <TemplateInfoDialog template={template} />
        </div>
      </ui.Card>
    </div>
  );
};
export const Route = createFileRoute("/_app/new/diary/invite/qr-code")({
  component: QRCodeInvitePage,
});
